<div>
    <app-header></app-header>
    <body class="body-container" [ngStyle]="{'background-color': '#EBEBEB'}">
        <div class="body-content">
            <div class="white-container">
                <h1 class="patient-appointment-section">Histórico de agendamentos</h1>
                <hr />
                <div class="row filters">
                    <form class="form" [formGroup]="model" (ngSubmit)="search()">
                        <div class="filters">
                            <div class="col-12 row">
                                <div class="col-6 col-md-6">
                                    <mat-form-field appearance="outline"
                                        [ngClass]="{ 'outline-spinner form-field-patient-center': !model.get('dateEnd').errors || !model.get('dateEnd').touched,'outline-spinner form-field-patient-center-error': model.get('dateEnd').errors && model.get('dateEnd').touched}">
                                        <mat-label>Período</mat-label>
                                        <mat-date-range-input [rangePicker]="picker">
                                            <input matStartDate formControlName="dateStart" readonly placeholder="Início" (dateChange)="verifyDateRange()">
                                            <input matEndDate formControlName="dateEnd" readonly placeholder="Fim" (dateChange)="verifyDateRange()">
                                        </mat-date-range-input>
            
                                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                        <mat-date-range-picker #picker></mat-date-range-picker>
                                        <mat-error *ngIf="model.get('dateStart')?.hasError('required') && model.get('dateEnd')?.hasError('required')">
                                            Data inicial e final é obrigatória .
                                        </mat-error>
                                        <mat-error *ngIf="model.get('dateStart')?.hasError('required') && !model.get('dateEnd')?.hasError('required')">
                                            Data inicial é obrigatória.
                                        </mat-error>
                                        <mat-error *ngIf="model.get('dateEnd')?.hasError('required') && !model.get('dateStart')?.hasError('required')">
                                            Data final é obrigatória.
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                                <div class="col-12 col-md-6">
                                    <mat-form-field appearance="outline"
                                        [ngClass]="{ 'outline-spinner form-field-patient-center': !model.get('idMedicalSpecialty').errors || !model.get('idMedicalSpecialty').touched,'outline-spinner form-field-patient-center-error': model.get('idMedicalSpecialty').errors && model.get('idMedicalSpecialty').touched}">
                                        <mat-label>Selecione a Especialidade</mat-label>
                                        <mat-select formControlName="idMedicalSpecialty">
                                            <mat-option [value]="null">Selecione...</mat-option>
                                            <mat-option *ngFor="let item of listMedicalSpecialty" [value]="item.medicalSpecialty.idMedicalSpecialty">
                                                {{item.medicalSpecialty.medicalSpecialtyName}}</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="col-12 row">
                                <div class="col-12 col-md-3 button-filter">
                                    <button mat-flat-button color="primary" class="btn-block primary-button" type="submit">
                                        <span class="label" *ngIf="!isLoading">Pesquisar</span>
                                        <mat-spinner [diameter]="30" class="mat-spinner-btn" *ngIf="isLoading"></mat-spinner>
                                    </button>
                                </div>
                                <div class="col-12 col-md-3 button-filter">
                                    <button mat-flat-button type="button" color="accent" class="btn-block secondary-button" (click)="cleanFilters()">
                                        <mat-icon *ngIf="!isLoading" aria-hidden="false" aria-label="Clear">cleaning_services</mat-icon>
                                        <span class="label" *ngIf="!isLoading">Limpar</span>
                                        <mat-spinner [diameter]="30" class="mat-spinner-btn" *ngIf="isLoading"></mat-spinner>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
                <div class="card-list" *ngIf="(listPastPatientAppointment && listPastPatientAppointment.length > 0) && !isLoading">
                    <div class="row">
                        <div class="col-12 col-sm-6 col-md-6" *ngFor="let item of listPastPatientAppointment">
                            <div class="card-item">
                                <div class="infos">
                                    <span class="primary">
                                        <mat-icon class="date-icon" matSuffix>today
                                        </mat-icon>
                                        {{item.datetimeStart | date:'dd/MM/yyyy'}} às
                                        {{item.datetimeStart | date:'HH:mm'}}
                                    </span>
                                    <span class="secundary">Dr(a). {{item.userName}}</span>
                                    <span class="secundary">{{item.medicalSpecialtyName}}</span>
                                    <span class="secundary">
                                        Atendimento: {{item.idTypeOfCare == 1 ? 'presencial' : 'telemedicina'}}
                                    </span>
                                    <span class="secundary">Status: {{item.appointmentStatusName}}</span>
                                </div>
                                <div class="button-container">
                                    <a mat-flat-button type="button" (click)="showDetails(item)"
                                        class="btn-block secondary-button">
                                        <span class="label">Ver detalhes</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="spinner-container" *ngIf="isLoading">
                    <mat-spinner [diameter]="30"></mat-spinner>
                </div>
                <div class="paginator-container" *ngIf="(listPastPatientAppointment && listPastPatientAppointment.length > 0)">
                    <div class="col-12 col-md-5">
                        <mat-paginator #paginator [length]="fullListSize" [pageIndex]="pageIndex" [pageSize]="pageSize"
                            aria-label="Select page" (page)="changePage($event)" [hidePageSize]="true">
                        </mat-paginator>
                    </div>
                </div>
                <div class="no-appointment"
                    *ngIf="(!listPastPatientAppointment || listPastPatientAppointment.length == 0) && !isLoading">
                    <span>
                        Não há consultas agendadas
                    </span>
                </div>
                <div class="footer-white-container">
                    <p>Central do paciente</p>
                </div>
                <button matTooltip="Voltar" mat-flat-button (click)="goBack()" class="btn-block secondary-button back">
                    <span class="label">Voltar</span>
                </button>
            </div>
        </div>
    </body>
</div>